import React from 'react';

import { Box, Typography } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import stylesMaterial from './stylesMaterial';

interface DeactivationWarningProps {
  text: string;
  description: string;
}

export function DeactivationWarning({
  text,
  description,
}: DeactivationWarningProps) {
  const classes = stylesMaterial();

  return (
    <Box title={description} className={classes.container}>
      <WarningIcon />
      <Typography className={classes.warningText}>{text}</Typography>
    </Box>
  );
}
